import { FIELD_TYPES } from '@/common-utils/components/renders/detailsGrid/FieldTypes';

const POSTERMINAL_STATS_FIELDS = {
    ACTIVE_SUB_BLOCKED_POS_COUNT: {
        key: 'activeSubBlockedPosCount',
        type: FIELD_TYPES.NUMBER
    },
    ACTIVE_SUBSCRIPTIONS_TOTAL: {
        key: 'activeSubscriptionsTotal',
        type: FIELD_TYPES.NUMBER
    },
    MANUFACTURER_BREAKDOWN: {
        key: 'manufacturerBreakdown',
        type: FIELD_TYPES.OBJECT
    },
    POS_STATUS_BREAKDOWN: {
        key: 'posStatusBreakdown',
        type: FIELD_TYPES.OBJECT
    },
    REMOTE_COLLECTION_24H_COUNT: {
        key: 'remoteCollection24hCount',
        type: FIELD_TYPES.NUMBER
    },
    COMMUNICATION_MODE_BREAKDOWN: {
        key: 'communicationModeBreakdown',
        type: FIELD_TYPES.OBJECT
    },
    TOP5_WHITE_LABEL: {
        key: 'top5WhiteLabel',
        type: FIELD_TYPES.OBJECT
    },
    TOP5_MERCHANT: {
        key: 'top5Merchant',
        type: FIELD_TYPES.OBJECT
    },
    FLOP5_MERCHANT: {
        key: 'flop5Merchant',
        type: FIELD_TYPES.OBJECT
    },
    FLOP5_WHITE_LABEL: {
        key: 'flop5WhiteLabel',
        type: FIELD_TYPES.OBJECT
    }
};

export default POSTERMINAL_STATS_FIELDS;
